if (!customElements.get('component-product-images')) {
  customElements.define('component-product-images', class ComponentProductImages extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.debouncedOnScroll = debounce(this.onScroll.bind(this));
      this.totalPages = Number(this.dataset.productImagesSize);
      this.totalPages = this.totalPages > 1 ? this.totalPages - 1 : this.totalPages;
      this.sliderWrapper = document.querySelector('.component-box');
      this.sliderImage = this.closest('.section-main-product').querySelector('.component-zoom-image-box');
      this.setActiveDot('first');
      this.addEventListeners();
    }

    onScroll(e) {
      const previousPage = this.currentPage || 0;
      this.currentPage = Math.round(this.sliderWrapper.scrollLeft / this.sliderWrapper.clientWidth);
      const isLastPage = this.totalPages === this.currentPage;
      const isFirstPage = this.currentPage === 0;
      const penultimateDotIndex = this.nextElementSibling.querySelectorAll('.dot').length - 1;
      const currentDotIndex = Number(this.nextElementSibling.querySelector('.dot-active').dataset.id);

      if (this.currentPage != previousPage) {
        if (isLastPage || this.currentPage > previousPage && this.currentPage < penultimateDotIndex) {
          this.nextElementSibling.setDot('next');
        } else if (isFirstPage || this.currentPage < previousPage && currentDotIndex != 1) {
          this.nextElementSibling.setDot('prev');
        }
      }
    }

    addEventListeners() {
      const productImages = this.querySelectorAll('.component-image-box-item');
      productImages.forEach(image => image.addEventListener('click', (e) => {
        const index = Number(e.target.dataset.index);
        this.setProductCarouselSliderIndex(index);
        this.openModal();
      }))
      this.sliderWrapper.addEventListener('scroll', this.debouncedOnScroll.bind(this));
    }

    openModal() {
      const modalOpener = document.querySelector('product-carousel-modal-opener');
      modalOpener._openModal();
    }

    setProductCarouselSliderIndex(index) {
      const productCarousel = document.querySelector('product-carousel');
      productCarousel.index = index;
    }

    setActiveDot(action) {
      const productImagesDotsComponent = this.nextElementSibling;
      productImagesDotsComponent && productImagesDotsComponent.setDot(action);
    }
  })
}
